/**
 * Date Field Type - Common
 *
 * Field-type configuration shared by the inline (inline/date.tsx) and
 * modal (modal/date.tsx) renderers.
 */

import type { FieldTypeConfig } from '../../components/types';
import { M } from './columnWidths';

// ============================================================================
// Field Type Configuration
// ============================================================================

/**
 * Date field type configuration
 */
export const dateFieldType: FieldTypeConfig = {
  placeholder: 'Select date...',
  ...M,
};
